// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3w0vs","inner":"Footer_inner__3ov4_"};